// olabi- mirta
// export const usePlans = true;
// export const useMaterialsPlan = false;
// export const usePrices = true;
// export const usePricingTypes = true;
// export const showEntityAddressInMenus = true;
// export const addingCustomerDirectly = true;
// export const useFinancialTarget = true;
// export const useNotifications = true;
// export const useVisitOrderRequest = false;

// export const useMaterialsSpecialtyVisits = false;
// export const deletionExternal = false

// ramapharma config
// export const usePlans = true;
// export const useMaterialsPlan = true;
// export const usePrices = false;
// export const usePricingTypes = false;
// export const showEntityAddressInMenus = false;
// export const addingCustomerDirectly = false;
// export const useFinancialTarget = false;
// export const useNotifications = false;
// export const useDirectEntityModify = false;
// export const useVisitOrderRequest = false;
// export const useMaterialsSpecialtyVisits = false;
// export const deletionExternal = false

// // Ibn-alhaytham
// export const usePlans = true;
// export const useMaterialsPlan = false;
// export const usePrices = false;
// export const usePricingTypes = false;
// export const showEntityAddressInMenus = false;
// export const addingCustomerDirectly = false;
// export const useFinancialTarget = false;
// export const useNotifications = false;
// export const useDirectEntityModify = false;
// export const useVisitOrderRequest = false;
// export const useVisitLocationCheck = false;
// export const useMaterialsSpecialtyVisits = false;
// export const deletionExternal = false

// oubari
export const usePlans = true;
export const useMaterialsPlan = false;
export const usePrices = false;
export const usePricingTypes = false;
export const showEntityAddressInMenus = false;
export const addingCustomerDirectly = false;
export const useFinancialTarget = false;
export const useNotifications = false;
export const useDirectEntityModify = false;
export const useVisitOrderRequest = false;
export const useVisitLocationCheck = false;
export const useMaterialsSpecialtyVisits = false;
export const deletionExternal = false

// right medical config
// export const usePlans = true;
// export const useMaterialsPlan = false;
// export const usePrices = false;
// export const usePricingTypes = false;
// export const showEntityAddressInMenus = false;
// export const addingCustomerDirectly = false;
// export const useFinancialTarget = false;
// export const useNotifications = false;
// export const useDirectEntityModify = false;
// export const useVisitOrderRequest = true;
// export const useVisitLocationCheck = true;
// export const useMaterialsSpecialtyVisits = false;
// export const deletionExternal = false

// Ibn-ALkhalil
// export const usePlans = true;
// export const useMaterialsPlan = true;
// export const usePrices = false;
// export const usePricingTypes = false;
// export const showEntityAddressInMenus = false;
// export const addingCustomerDirectly = false;
// export const useFinancialTarget = false;
// export const useNotifications = false;
// export const useDirectEntityModify = true;
// export const useVisitOrderRequest = false;
// export const useMaterialsSpecialtyVisits = true;
// export const deletionExternal = false

// media pharma
// export const usePlans = true;
// export const useMaterialsPlan = false;
// export const usePrices = false;
// export const usePricingTypes = true;
// export const showEntityAddressInMenus = true;
// export const addingCustomerDirectly = true;
// export const useFinancialTarget = true;
// export const useNotifications = true;
// export const useDirectEntityModify = true;
// export const useVisitOrderRequest = false;
// export const useMaterialsSpecialtyVisits = false;
// export const deletionExternal = false
